import type { ApiActionStatus } from './utils';
import type { DirectHotelProvider } from './directHotelPrices';

export enum KayakHotelProvider {
    REVATO = 'REVATO',
    STRAWBERRY = 'CHOICENORDIC',
}

export interface HotelProvider {
    code: KayakHotelProvider | DirectHotelProvider;
    name: string;
    parentProvider?: HotelProvider;
    logo?: string;
    isDirect: boolean;
    isLanguageSupported?: boolean;
    nameOverrideOutPage?: string;
    nameOverrideSearchResults?: string;
}

export interface VisBookProductAndPrice {
    productId?: number;
    priceId?: number;
}

export interface ThonRoomAndRate {
    ratePlanCode?: string;
    roomTypeCode?: string;
}

export interface HCOffer {
    roomName: string;
    totalRate: number;
    isBundledRate: boolean;
    hasFreeCancellation: boolean;
    canPayLater: boolean;
    inclusions?: readonly number[];
    availableRooms: number;
    providerIndex: number;
    bookUri: string;
}

export interface HotelImage {
    small?: string;
    large: string;
    caption?: string;
}

export interface AutocompleteDestination {
    text: string;
    key?: string;
    hierarchy: string[];
    searchable: boolean;
    type: 'hotel' | 'place' | 'country' | 'theme';
    themePath?: string;
}

export interface HotelOffer {
    id: string;
    rooms: readonly HotelRoom[];
    totalRate: number;
    isBundledRate?: boolean;
    hasFreeCancellation: boolean;
    canPayLater: boolean;
    inclusions: readonly string[];
    availableRooms?: number;
    provider: HotelProvider;
    encryptedParams: string;
    country?: string;
    place?: string;
    checkInDate?: Date | number;
    checkOutDate?: Date | number;
    hotelKey?: string;
    hotelId?: number;
    isDirect: boolean;
    integratedBooking: boolean;
    bookingParams?: string;
    loginRequired?: boolean;
    handicapRoomWeighting: number;
}

export interface HotelRoom {
    name: string;
    description?: string;
    image?: string;
    price?: number;
}

export interface PlaceRef {
    key: string;
    name: string;
}

export interface BasicHotelsResponse {
    status: ApiActionStatus;
    isComplete: boolean;
    attempts: number;
    totalResults?: number;
    totalAvailableResults?: number;
    totalFilteredResults?: number;
    results: readonly BasicHotel[];
}

export interface BasicHotel {
    id: number;
    key: string;
    href?: string;
    name: string;
    latitude: number;
    longitude: number;
    starRating: number;
    guestRating: number;
    lowestRate: number;
    image: HotelImage;
}
